module.exports = __webpack_public_path__ + "public/img/wuyut_ldfc1.17558222.jpg";